import React from "react";
import { Box, Button, Text, UnstyledButton } from "@mantine/core";
import { IconArrowsSort } from "@tabler/icons-react";
import { lineItemsLabel } from "../v2/ReportActionRow";
import { CardExpansion } from "./cards/useCardExpansion";
import styles from "./MobileReportCanvas.module.css";

export interface MobileActionRowProps {
  /** Line items in the result; null before the first result. */
  lineCount: number | null;
  /** A newer run is loading: the count shown is the previous run's. */
  loading: boolean;
  expansion: CardExpansion;
  hasCards: boolean;
  /** A sort other than the default is applied. */
  sorted: boolean;
  onOpenSort: () => void;
}

/** Above the cards: line-item count, Expand / Collapse all, and Sort. */
export default function MobileActionRow({
  lineCount,
  loading,
  expansion,
  hasCards,
  sorted,
  onOpenSort,
}: MobileActionRowProps) {
  return (
    <Box className={styles.actionRow}>
      <Text className={styles.count} data-loading={loading || undefined}>
        {lineCount === null ? "" : lineItemsLabel(lineCount)}
      </Text>
      <Box className={styles.spacer} />
      {hasCards && (
        <UnstyledButton
          type="button"
          className={styles.linkButton}
          onClick={
            expansion.anyOpen ? expansion.collapseAll : expansion.expandAll
          }
        >
          {expansion.anyOpen ? "Collapse all" : "Expand all"}
        </UnstyledButton>
      )}
      <Button
        variant={sorted ? "light" : "default"}
        color={sorted ? "teal" : undefined}
        size="xs"
        leftSection={<IconArrowsSort size={14} aria-hidden />}
        onClick={onOpenSort}
      >
        {sorted ? "Sorted" : "Sort"}
      </Button>
    </Box>
  );
}
